module.exports = __webpack_public_path__ + "img/Lifan.baabce3c.png";